import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import CatalogView from "@/components/feature/CatalogView";
import { useSeo } from "@/hooks/useSeo";

export default function MoviePage() {
  useSeo({
    title: "电影 - 飘花电影网",
    description:
      "飘花电影网电影分类页，汇集动作、喜剧、爱情、科幻、悬疑等类型的最新电影资源，支持按类型、地区、年份筛选与排序，快速找到想看的影片。",
    keywords: "最新电影,电影大全,动作片,科幻片,悬疑片,飘花电影网",
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-100">
      <SiteHeader />
      <main className="flex-1">
        <CatalogView type="movie" />
      </main>
      <SiteFooter />
    </div>
  );
}